import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer>
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>MoleCorp</h3>
            <p>{t('footer.description')}</p>
          </div>
          <div className="footer-section">
            <h3>{t('footer.services')}</h3>
            <Link to="/services">{t('services.web.title')}</Link>
            <Link to="/services">{t('services.mobile.title')}</Link>
            <Link to="/services">{t('services.community.title')}</Link>
            <Link to="/services">{t('services.gaming.title')}</Link>
          </div>
          <div className="footer-section">
            <h3>{t('footer.company')}</h3>
            <Link to="/about">{t('nav.about')}</Link>
            <Link to="/contact">{t('nav.contact')}</Link>
            <Link to="/privacy-policy">{t('privacy.title')}</Link>
            <Link to="/terms-of-service">{t('terms.title')}</Link>
          </div>
          <div className="footer-section">
            <h3>{t('footer.contact_info')}</h3>
            <p>Email: info@molecorp.club</p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} MoleCorp. {t('footer.rights')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

